import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { name: "About", href: "#about" },
  { name: "My Method", href: "#approach" },
  { name: "Services", href: "#services" },
  { name: "Sample Plan", href: "#sample-plan" },
  { name: "Transformations", href: "#transformations" },
  { name: "FAQ", href: "#faq" },
  { name: "Gallery", href: "/gallery" },
];

export default function Navbar({ crossPage = false }) {
  const [open, setOpen] = useState(false);
  const resolve = (h) => (crossPage && h.startsWith("#") ? `/#${h.slice(1)}` : h);

  const renderLink = (l, className, testid) =>
    l.href.startsWith("/") ? (
      <Link key={l.name} to={l.href} className={className} data-testid={testid} onClick={onClose}>
        {l.name}
      </Link>
    ) : (
      <a key={l.name} href={resolve(l.href)} className={className} data-testid={testid} onClick={onClose}>
        {l.name}
      </a>
    );

  const onClose = () => setOpen(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-ink/80 border-b border-line/80">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-20 flex items-center justify-between">
        <Logo />
        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) =>
            renderLink(
              l,
              "relative whitespace-nowrap text-sm font-medium text-slate-300 hover:text-white transition-colors after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:w-0 after:bg-accent after:transition-all after:duration-300 hover:after:w-full",
              `nav-link-${l.name.toLowerCase().replace(/\s+/g, "-")}`
            )
          )}
          <a
            href={resolve("#intake-form")}
            data-testid="nav-cta-apply-btn"
            className="px-6 py-2.5 rounded-full bg-gold text-ink text-sm font-extrabold uppercase tracking-wide whitespace-nowrap transition-all duration-300 hover:shadow-glow-gold hover:-translate-y-0.5"
          >
            Apply For Coaching
          </a>
        </div>
        <button
          className="lg:hidden p-2 text-slate-200"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="lg:hidden overflow-hidden bg-ink/95 border-b border-line"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) =>
                renderLink(
                  l,
                  "font-display uppercase text-lg font-bold text-slate-200",
                  `nav-mobile-link-${l.name.toLowerCase().replace(/\s+/g, "-")}`
                )
              )}
              <a
                href={resolve("#intake-form")}
                onClick={onClose}
                data-testid="nav-mobile-cta-apply-btn"
                className="mt-2 text-center px-6 py-3 rounded-full bg-gold text-ink font-extrabold uppercase tracking-wide"
              >
                Apply For Coaching
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}